export default "/assets/images/gamer-room-video.6715151f52300ad2.mp4";